// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

import { Component, OnInit, OnDestroy, AfterViewInit, Input, TemplateRef, ViewChild, Output, EventEmitter, HostBinding } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatSnackBar, MatDialog } from '@angular/material';
import { fadeInOut } from '../../services/animations';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { AccountService } from "../../services/account.service";
import { Product } from 'src/app/models/product.model';
import * as FileSaver from 'file-saver'; 
import { DecimalPipe } from '@angular/common';
import { ExcelFisier } from 'src/app/models/ExcelFisier.model';
import { CatalogLink } from 'src/app/models/catalogLink.model';

@Component({
  selector: 'product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
    animations: [fadeInOut]
})

export class ProductComponent
{
  private isSaving: boolean;
  private isNew: boolean;
  productForm: FormGroup;
  product: Product;
  definireProduct: boolean = false;
  afisareProduct: boolean = true;
  afisareIncarcareExcel: boolean = false;
  afisareActualizarePreturi: boolean = false;

  vehicleReference: string = '';
  productnumber: string = '';
  displayedColumns = ['actions', 'vehicleReference', 'productnumber', 'productgrup', 'description', 'descriptionfr', 'descriptionro', 'descriptionen', 'pricedealer', 'pricefinalcustomer'/*,'linkcatalog'*/];
  displayedColumnsProducts = ['select', 'vehicleReference', 'productgrup', 'productnumber'];
  isDataLoaded: boolean = false;
  loadingIndicator: boolean = true;
  formResetToggle: boolean = true;
  selectDepedentProduct: boolean = false;
  _currentUserId: string;
  data: Product[];
  dataSource: MatTableDataSource<Product>;
  dataSourceProducts: MatTableDataSource<Product>;
  catalogLink: CatalogLink[];
  dataSelectedProducts: Product[];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  afiseazaDate() {
    this.loadingIndicator = true;

    let vehicleReference = this.vehicleReference == null || this.vehicleReference == "" ? "undefined" : this.vehicleReference;
    let productnumber = this.productnumber == null || this.productnumber == "" ? "undefined" : this.productnumber;
    
    this.accountService
      .getProductLists("undefined", "undefined", "undefined", "undefined", "undefined", "undefined", "undefined", vehicleReference, "undefined", productnumber)
      .subscribe(results => {

        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));

        this.data = liniiReconverted;
        
        this.dataSource.data = this.data;

        this.isDataLoaded = true;

        setTimeout(() => { this.loadingIndicator = false; }, 1500);

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
        error => {
        });

  }

  getCatalogLinkList() {
    this.accountService.getCatalogLinkLists()
      .subscribe(results => {
        let linii = results[0];
        let liniiReconverted = JSON.parse(JSON.stringify(linii));
        this.catalogLink = liniiReconverted;
      },
        error => {
        });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  reset() {
    this.vehicleReference = '';
    this.productnumber = '';
    this.afiseazaDate();
  }

  modificare(product: Product) {
    this.selectDepedentProduct = false;
    this.dataSelectedProducts = [];
    this.dataSourceProducts.data = [];
    this.definireProduct = true;
    this.afisareProduct = false;
    this.afisareIncarcareExcel = false;
    this.afisareActualizarePreturi = false;
    this.product = product;

    if (this.product.depedentProduct != null) {
      this.selectDepedentProduct = true;
      this.selectedDepedentProduct(true);
    }

  }

  verificareStergere(product: Product) {
    this.alertService.showDialog('Delete', 'Do you confirm the deletion?', DialogType.confirm, () => this.stergeProduct(product));
  }

  stergeProduct(product: Product) {
    product.status = "D";
    this.accountService.saveProduct(product).subscribe(
      role => {
        this.saveSuccessHelper(this.product, `Vehicle deleted!`);
        this.afiseazaDate();
      },
      error => this.saveFailedHelper(error));
  }

  adaugare() {
    this.selectDepedentProduct = false;
    this.dataSelectedProducts = [];
    this.dataSourceProducts.data = [];
    this.definireProduct = true;
    this.afisareIncarcareExcel = false;
    this.afisareActualizarePreturi = false;
    this.afisareProduct = false;
    this.product = new Product();
  }
  
  constructor(
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
  )
  {
    this.dataSource = new MatTableDataSource<Product>();
    this.dataSourceProducts = new MatTableDataSource<Product>();
    this.buildForm();
  }

  ngOnInit() {
    this.product = new Product();
    this.afiseazaDate();
    this.getCatalogLinkList();
  }
  
  save() {
    if (this.productForm.valid) {
      
      this.product.depedentProduct = "";

      for (let product of this.dataSelectedProducts.filter(f => f.selected === true)) {
        this.product.depedentProduct += product.id + "#";
      }
      
      this.accountService.saveProduct(this.product).subscribe(
        role => this.saveSuccessHelper(this.product, `Vehicle product saved successfully!`),
        error => this.saveFailedHelper(error));
    } else {
      alert("form invalid!");
    }

    this.afisareProduct = true;
    this.definireProduct = false;
    this.afisareIncarcareExcel = false;
    this.afisareActualizarePreturi = false;
  }

  private saveSuccessHelper(product?: Product, mesaj?: string) {
    this.isSaving = false;
    this.alertService.stopLoadingMessage();

    this.alertService.showMessage("Success", mesaj, MessageSeverity.success);

    this.definireProduct = false;
    this.afiseazaDate();
  }

  private saveFailedHelper(error: any) {
    this.isSaving = false;
    this.alertService.stopLoadingMessage();
    this.alertService.showStickyMessage("Save Error", "Errors: ", MessageSeverity.error, error);
    this.alertService.showStickyMessage(error, null, MessageSeverity.error);
  }

  private buildForm() {
    this.productForm = this.formBuilder.group({
      tbDescription: ['', [Validators.required],],
      tbPricedealer: ['', [Validators.required],],
      tbPricefinalcustomer: ['', [Validators.required],],
      tbDescriptionfr: ['', [Validators.required],],
      tbProductgrup: ['', [Validators.required],],
      tbDescriptionro: ['', [Validators.required],],
      tbDescriptionen: ['', [Validators.required],],
      tbProductnumber: ['', [Validators.required],],
      tbVehicleReference: ['', [Validators.required],],
      tbCatalogreference: ['', [Validators.required],],
      tbSerialNumber: [''],
      tbSelectDepedentProduct: [''],
    });
  }

  get tbDescription() {
    return this.productForm.get('tbDescription');
  }

  get tbPricedealer() {
    return this.productForm.get('tbPricedealer');
  }

  get tbPricefinalcustomer() {
    return this.productForm.get('tbPricefinalcustomer');
  }

  get tbDescriptionfr() {
    return this.productForm.get('tbDescriptionfr');
  }

  get tbProductgrup() {
    return this.productForm.get('tbProductgrup');
  }

  get tbDescriptionro() {
    return this.productForm.get('tbDescriptionro');
  }

  get tbDescriptionen() {
    return this.productForm.get('tbDescriptionen');
  }

  get tbProductnumber() {
    return this.productForm.get('tbProductnumber');
  }

  get tbCatalogreference() {
    return this.productForm.get('tbCatalogreference');
  }

  get tbVehicleReference() {
    return this.productForm.get('tbVehicleReference');
  }

  get tbSerialNumber() {
    return this.productForm.get('tbSerialNumber');
  }
  
  get tbSelectDepedentProduct() {
    return this.productForm.get('tbSelectDepedentProduct');
  }

  private cancel() {
    this.definireProduct = false;
    this.afisareProduct = true;
    this.afisareIncarcareExcel = false;
    this.afisareActualizarePreturi = false;
    this.afiseazaDate();
  }

  openPanel_IncarcaFisierExcel() {
    this.afisareIncarcareExcel = true;
    this.afisareActualizarePreturi = false;
    this.definireProduct = false;
    this.afisareProduct = false;
  }

  openPanel_ActualizarePreturi() {
    this.afisareIncarcareExcel = false;
    this.afisareActualizarePreturi = true;
    this.definireProduct = false;
    this.afisareProduct = false;
  }

  facturiDeIncarcat: ExcelFisier[];

  fileToUpload: File = null;
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  uploadFileToActivity() {
    //this.afisareIncarcareExcel = false;
    this.alertService.startLoadingMessage("File upload is in progress...");

    this.facturiDeIncarcat = [];

    if (this.fileToUpload === null) {
      this.alertService.stopLoadingMessage();
      this.alertService.showStickyMessage("File upload error", "The file is not selected!", MessageSeverity.error);
      return;
    }

    const formData = new FormData();
    formData.append('file', this.fileToUpload, this.fileToUpload.name);

    this.accountService.uploadFile("admin", formData).subscribe((result) => {
      if (result != null) {
        if (result.length > 0) {
          let liniiReconverted = JSON.parse(JSON.stringify(result[0]));
          this.facturiDeIncarcat = liniiReconverted;
        }
      }

      this.alertService.stopLoadingMessage();
      this.alertService.showStickyMessage("File upload", "The file was uploaded successfully!", MessageSeverity.success);
      //this.afisareIncarcareExcel = true;
    },
      error => {
        //this.afisareIncarcareExcel = true;
      });
  }

  incarcaFisier() {
    this.uploadFileToActivity();
    this.afisareProduct = true;
    this.definireProduct = false;
    this.afisareIncarcareExcel = false;
    this.afisareActualizarePreturi = false;
  }

  uploadPriceFileToActivity() {
    this.alertService.startLoadingMessage("File upload is in progress...");

    this.facturiDeIncarcat = [];

    if (this.fileToUpload === null) {
      this.alertService.stopLoadingMessage();
      this.alertService.showStickyMessage("File upload error", "The file is not selected!", MessageSeverity.error);
      return;
    }

    const formData = new FormData();
    formData.append('file', this.fileToUpload, this.fileToUpload.name);

    this.accountService.uploadPriceFile("admin", formData).subscribe((result) => {
      if (result != null) {
        if (result.length > 0) {
          let liniiReconverted = JSON.parse(JSON.stringify(result[0]));
          this.facturiDeIncarcat = liniiReconverted;
        }
      }

      this.alertService.stopLoadingMessage();
      this.alertService.showStickyMessage("File upload", "The update prices successfully!", MessageSeverity.success);
    },
      error => {

      });
  }

  incarcaFisierActualizarePreturi() {
    this.uploadPriceFileToActivity();
    this.afisareProduct = true;
    this.definireProduct = false;
    this.afisareIncarcareExcel = false;
    this.afisareActualizarePreturi = false;
  }

  selectedDepedentProduct(event) {

    if (this.selectDepedentProduct === true) {

      if (this.product.vehicleReference === undefined || this.product.vehicleReference === "") {
        this.selectDepedentProduct = false;
        this.alertService.showDialog('Warning!', 'Please enter vehicle reference!', DialogType.alert, () => { });
        return;
      }

      this.accountService
        .getProductLists("undefined", "undefined", this.product.vehicleReference)
        .subscribe(results => {
          let linii = results[0];

          let liniiReconverted = JSON.parse(JSON.stringify(linii));

          this.dataSourceProducts.data = liniiReconverted;

          if (this.product.depedentProduct != null) {
            let idProducts = this.product.depedentProduct.split('#');

            for (var i = 0; i <= idProducts.length; i++) {
              let productInList = this.dataSourceProducts.data.find(f => f.id == idProducts[i]);
              if (productInList != null) {
                this.dataSelectedProducts.push(productInList);
                productInList.selected = true;
              }
            }

            for (let product of this.dataSourceProducts.data) {
              for (let selectedProduct of this.dataSelectedProducts) {
                if (product.id == selectedProduct.id) {
                  product.selected = true;
                }
              }
            }
          }

          this.isDataLoaded = true;

          setTimeout(() => { this.loadingIndicator = false; }, 1500);
        });
    }
    else {
      this.dataSelectedProducts = [];
    }
  }

  MarkSelectionOfProduct(product: Product) {
    let currentProductInList = this.dataSelectedProducts.find(f => f.id === product.id);
    if (product.selected) {
      if (currentProductInList == null) {
        this.dataSelectedProducts.push(product);
      }
    }
    else {
      if (currentProductInList !== null) {
        this.dataSelectedProducts = this.dataSelectedProducts.filter(obj => obj !== currentProductInList);
      }
    }
  }

}
